module.exports = __webpack_public_path__ + "img/banner.0f651216.jpg";